export default __webpack_public_path__ + "static/media/villain.9b4975cd.png";